import { FONTS } from "./inputValues";

export const designTypes = {
  base: "base",
  art: "art",
};

export const qrSettingsInitialState = {
  pattern: "square",
  patternColor: "#000000",
  patternBackground: "#ffffff",
  qrBackgroundColor: "#ffffff",
  patternBackgroundTransparent: false,
  cornetsOuter: null,
  cornetsOuterColor: "#000000",
  cornetsInterior: null,
  cornetsInteriorColor: "#000000",
  logotype: null,
  logotypeSize: 0.3,
  logotypeMargin: 2,
  logotypeBackground: true,
  isSingleColorDots: true,
  isSingleColorExternalEye: true,
  isSingleColorInternalEye: true,
  isSingleColorBackground: null,
  gradientDots: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  gradientExternalEye: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  gradientInternalEye: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  gradientBackground: {
    type: "linear",
    rotation: 0,
    colorStops: [
      { offset: 0, color: "#F48F8F" },
      { offset: 1, color: "#E34C4C" },
    ],
  },
  backgroundImage: null,
  backgroundImageSize: 0.8,
};

export const qrFramesInitialState = {
  frame: "noFrame",
  frameColor: "#000000",
  frameTransform: "translate(9, 9)scale(0.95)",
  transformFrameText: "translate(150,295)",
  frameTextColor: "#9c3aaf",
  frameTextToggle: false,
  frameTextFont: FONTS[0],
};

export const qrOptionsInitialState = {
  errorCorrectionLevel: "Q",
};

export const qrTextInitialState = {
  frameText: "",
  draggableText: "",
  fontFamily: "font-family: 'Poppins', sans-serif;",
  fontWeight: 400,
  textSize: -1,
};
